import { PeopleApi, ClubApi } from 'api'
import { TopLevelPage } from 'ui'
import { withErrorBoundary, connected, SearchBar } from 'shared'
import { Spinner, NoResults } from 'shared'
import { SmartButton } from 'ui/smart-buttons'
import SmartButtonApi  from 'api/smart-button-api'
import PersonModal from './PersonModal'
import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import useForceUpdate from 'hooks/useForceUpdate'

const PeopleList = ({ loggedInUser, match, reloadSmartButtons, smartButtons }) => {
  const [state, setState] = useState({ currentPage: 1, totalPage: 1, selectedUser: loggedInUser })

  const queryRef = useRef(PeopleApi.paramsFor('index').q)

  useEffect(() => {
    fetchCurrentUser();
  }, [])

  const forceUpdate = useForceUpdate()
  const fetchCurrentUser = async () => {
    try {
      const response = await Backend.get('/users/me');
      setState({ ...state, selectedUser: response.user });
    } catch (error) {
      console.error('Error fetching current user:', error);
    }
  };

  const handleUserClick = (user) => {
    setState({ ...state, selectedUser: user })
  }

  const handlePreviousPage = () => {
    setState((prevState) => ({ ...prevState, currentPage: prevState.currentPage - 1 }));
  };

  const handleNextPage = () => {
    setState((prevState) => ({ ...prevState, currentPage: prevState.currentPage + 1 }));
  };

  const queryDidChange = query => { queryRef.current = query }
  const queryWouldSubmit = () => { forceUpdate() }

  let { id, club_id, args, place_checkins, reserved_event_id } = match.params
  let { currentPage, selectedUser } = state
  let { totalPage } = state

  let base
  if (club_id){
    base = args ? `people::${args}` : `people/club/${club_id}`
  }
  else if(place_checkins){
    base = args ? `people::${args}` : `people/place_checkins/${place_checkins}`
  }
  else if(reserved_event_id){
    base = args ? `people::${args}` : `people/event/${reserved_event_id}`
  }
  else{
    base = args ? `people::${args}` : `people`
  }

  let urlParams = new URLSearchParams(args)
  let userRoleId = urlParams.get('role')
  let club_models = ClubApi.kick('joined')
  let models = PeopleApi.kick('index', {
                q: queryRef.current, user_role_id: userRoleId, club_id: club_id, place_checkins: place_checkins,
                reserved_event_id: reserved_event_id, page: currentPage })

  if (models && models.length != 0){
    let lastIndex = models.length - 1
    totalPage = models[lastIndex].totalPages
  }

  return (
    <TopLevelPage className="People" fullWidth modelId={id} base={"/" + base}>
      <h1 className="visually-hidden">
        People Page
      </h1>
      <div className="entity-smart-buttons smart-buttons">
        {smartButtons &&
          smartButtons.map((smartButton) => (
            <SmartButton
              {...{ smartButton, reloadSmartButtons, base }}
              key={smartButton.key}
              returnPath={application.path}
            />
          ))}
      </div>
      <div className="body">
        <div className="left-pane">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <SearchBar
                onChange={queryDidChange}
                onSubmit={queryWouldSubmit}
                initialQuery={queryRef.current}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                {models == null ? (
                  <Spinner />
                ) : models.length == 0 ? (
                  <NoResults />
                ) : (
                  <div className="table-responsive">
                  <table className="person-table table">
                    <thead>
                      <tr>
                        <th scope="col">Avatar</th>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Email</th>
                        <th scope="col">Followers</th>
                      </tr>
                    </thead>
                    <tbody>
                      {models.map((user) => (
                        <tr
                          key={user.uid}
                          className="person-table-row event-information-detail"
                          onClick={() => handleUserClick(user)}
                        >
                          <td className="person-avatar-cell">
                            {user.picture && (
                              <Link
                                to={`people/${user.uid}`}
                                className="plain-link"
                              >
                                <img
                                  src={user.picture}
                                  className="person-avatar rounded-circle"
                                  alt={user.name ? `${user.name}'s profile picture` : 'User profile picture'}
                                />
                              </Link>
                            )}
                          </td>
                          <td>
                            {club_id && user.uid ? (
                              <Link
                                to={`${club_id}/${user.uid}`}
                                className="plain-link"
                              >
                                {user.name}
                              </Link>
                            ) : reserved_event_id && user.uid ? (
                              <Link
                                to={`${reserved_event_id}/${user.uid}`}
                                className="plain-link"
                              >
                                {user.name}
                              </Link>
                            ) : place_checkins && user.uid ? (
                              <Link
                                to={`${place_checkins}/${user.uid}`}
                                className="plain-link"
                              >
                                {user.name}
                              </Link>
                            ) : (
                              <div
                                to={`people/${user.uid}`}
                                className="plain-link"
                                style={{ cursor: 'pointer' }}
                              >
                                {user.name}
                              </div>
                            )}
                          </td>
                          <td>{user.phone}</td>
                          <td>{user.email}</td>
                          <td
                            className="person-followers-cell"
                            style={{ color: '#333', fontWeight: '600' }}
                          >
                            {user.result_based_on_settings_identifier}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                )}
              </div>
              <div className="pagination-bar d-flex justify-content-center align-items-center my-3">
                <button
                  disabled={currentPage === 1}
                  onClick={handlePreviousPage}
                  className="smart-button btn mx-2"
                >
                  Previous
                </button>
                <span className="mx-2">
                  Page {currentPage} of {totalPage}
                </span>
                <button
                  disabled={currentPage === totalPage}
                  onClick={handleNextPage}
                  className="smart-button btn mx-2"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="right-pane">
          <div className="card">
            {selectedUser && (
              <PersonModal
                person={selectedUser}
                base={base}
                smartButtons={smartButtons}
                reloadSmartButtons={reloadSmartButtons}
                showPrivacySettings={selectedUser.id === User.current.id}
              />
            )}
          </div>
        </div>
      </div>
    </TopLevelPage>
  )
}

PeopleList.propTypes = {
  match: PropTypes.object,
  loggedInUser: PropTypes.object.isRequired,
}

PeopleList.requestSmartButtons = (success) => {
  return SmartButtonApi.forUsers(success)
}

export default SmartButton.containerComponent(null, withErrorBoundary(connected(PeopleList)), { Source: PeopleList })
